<template>
  <div>
    <v-form @submit.prevent="handleSubmitForm" class="user-form">
      <v-card :loading="form_loading">
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon>mdi-person</v-icon>
            {{ getCardTitle() }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="handleCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <ValidationObserver ref="forms" v-slot="{ invalid }">
            <v-alert type="error" class="mt-2" v-if="form_message">{{
              form_message
            }}</v-alert>
            <v-container>
              <ValidationProvider
                name="name"
                rules="required|max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Nome Completo"
                  name="name"
                  type="text"
                  :counter="45"
                  v-model="form.name"
                  :error-messages="errors"
                  :disabled="form_loading"
                />
              </ValidationProvider>
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Email"
                  name="email"
                  type="email"
                  :counter="100"
                  v-model="form.email"
                  :error-messages="errors"
                  :disabled="form_loading"
                />
              </ValidationProvider>
              <ValidationProvider
                name="password"
                :rules="form.id ? '' : 'required'"
                v-slot="{ errors }"
              >
                <v-text-field
                  id="password"
                  label="Senha"
                  name="password"
                  v-model="form.password"
                  :error-messages="errors"
                  :disabled="form_loading"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  :hint="id ? 'Deixe em branco para não alterar' : ''"
                  persistent-hint
                />
              </ValidationProvider>

              <ValidationProvider
                name="role_id"
                :rules="''"
                v-slot="{ errors }"
              >
                <role-select
                  v-model="form.role_id"
                  :error-messages="errors"
                  :disabled="form_loading"
                  name="role_id"
                  label="Função"
                  chips
                ></role-select>
              </ValidationProvider>

              <v-radio-group
                v-model="form.is_admin"
                row
                color="primary"
                :disalbed="form_loading"
              >
                <v-radio
                  color="primary"
                  label="Padrão"
                  :value="false"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Administrador"
                  :value="true"
                ></v-radio>
              </v-radio-group>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleCancel" text :disabled="form_loading">
            Cancelar
          </v-btn>
          <v-btn type="submit" color="primary" :loading="form_loading">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import RoleSelect from "../forms/RoleSelect";

export default {
  name: "user-form",
  components: { RoleSelect },
  model: {
    prop: "id",
    event: "change"
  },
  props: ["id"],
  data: () => ({
    form: {
      is_admin: false
    },
    show: false,
    form_loading: false,
    form_message: ""
  }),
  methods: {
    getCardTitle() {
      return this.id ? this.form.name : "Novo usuário";
    },
    handleCancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    fetchUser(id) {
      return this.$http.get(`/users/${id}`);
    },
    storeUser(payload) {
      return this.$http.post("/users", payload);
    },
    updateUser(payload, id) {
      return this.$http.put(`/users/${id}`, payload);
    },
    resetForm() {
      this.form = {
        is_admin: false
      };
      this.$refs.forms.reset();
    },
    async findUser(id) {
      this.form_loading = true;
      try {
        const response = await this.fetchUser(id);
        this.form = response.data.user;
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: e.message
        });
      } finally {
        this.form_loading = false;
      }
    },
    async handleSubmitForm() {
      const validation = await this.$refs.forms.validate();

      if (validation) {
        const payload = {
          ...this.form,
          password: this.form.password ? this.form.password : null,
          role_id: this.form.role_id ? this.form.role_id : null
        };
        this.form_loading = true;
        try {
          let response = null;
          let message = "Registro atualizado";
          if (this.id) {
            await this.updateUser(payload, this.id);
          } else {
            message = "Registro criado com sucesso";
            await this.storeUser(payload);
          }
          this.resetForm();
          this.$emit("submit");
          this.$store.commit("sendMessage", {
            text: message
          });
        } catch (e) {
          this.$refs.forms.setErrors(e.response.data.errors);
          this.$store.commit("sendMessage", {
            text: `(${e.response.status}) ${e.response.data.message}`,
            color: "red"
          });
        } finally {
          this.form_loading = false;
        }
      }
    }
  },
  created() {
    if (this.id == null) {
    } else {
      this.findUser(this.id);
    }
  },

  watch: {
    id: function(value, old_value) {
      if (value == null) {
        this.resetForm();
      } else {
        this.findUser(value);
      }
    }
  }
};
</script>

<style lang="scss">
.user-form {
}
</style>
